import { FC, useMemo } from 'react';

import { convertCentsToRubles, convertRublesToCents, formatCost } from 'utils/clickme';

import useTrls from 'hooks/translation/useTrls';

import { MagritteFormField } from 'components/common/MagritteFormField/MagritteFormField';
import { MoneyInput } from 'components/common/MoneyInput/MoneyInput';
import { useMinBudget } from 'components/CpcFlexibleCreate/CpcForm/AdBudget/useMinBudget';

import { setCampaignDailyBudget } from 'store/models/createCampaign';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    label: 'AdCreate.AdForm.AdDailyBudget.label',
    placeholder: 'AdCreate.AdForm.AdDailyBudget.input.placeholder',
};

export const DailyBudget: FC = () => {
    const { adDailyBudget, campaignErrors } = useSelector((state) => state.createCampaign);
    const { adDailyBudget: errorAdDailyBudget } = campaignErrors;

    const dailyBudget = useMemo(
        () => (adDailyBudget === null ? '' : convertRublesToCents(adDailyBudget)),
        [adDailyBudget]
    );

    const { minDailyBudget } = useMinBudget();

    const dispatch = useDispatch();
    const trl = useTrls();

    const onChangeDailyBudget = (value: string) => {
        const valueInRubble = convertCentsToRubles(value, 0);
        dispatch(setCampaignDailyBudget(valueInRubble));
    };

    return (
        <MagritteFormField
            label={trl(TrlKeys.label)}
            input={
                <MoneyInput
                    value={dailyBudget}
                    onChange={onChangeDailyBudget}
                    placeholder={trl(TrlKeys.placeholder, [formatCost(minDailyBudget)])}
                    data-qa="daily-budget-input"
                    invalid={!!errorAdDailyBudget}
                    errorMessage={errorAdDailyBudget}
                    clearableOnFocus
                />
            }
        />
    );
};
